import gql from 'graphql-tag'

const updateCliente = gql`
  mutation updateClienteWithTags($cliente: UpdateCliente!, $id: Int!, $zone: String, $interessi: String) {
    updateClienteWithTags(cliente: $cliente, id: $id, zone: $zone, interessi: $interessi) {
      id
      agenteId
      nome
      comune
      email
      email2
      telefono
      telefono2
      dataNascita
      lingua
      tipoPnl
      famiglia
      percheCompra
      quandoInteressato
      quantoInteressato
      voto
      dataCreazione
      daRicontattare
      dataUltimoContatto
      dataUltimaRichiesta
      zone {
        nome
      }
      interessi {
        nome
      }
    }
  }
`

export default updateCliente


// WEBPACK FOOTER //
// ./src/graphql/mutations/updateCliente.js